<template>
    <div class="qr-wrapper html2pdf__page-break">
      <div class="corner-top-left"></div>
      <div class="corner-top-right"></div>
      <div class="hero-qr">
        <h1 v-html="productCategory"></h1>
      </div>
      <div class="qr-items-content">
        <h3 class="content-margin-top">
            {{ product.brand && product.brand.name }}
        </h3>
        <h2 class="content-margin-top">
            {{ product.name }}
        </h2>
        <div class="plant-type-wrapper content-margin-top">
          <p  class="color-primary">{{ variant.size ? variant.size : '-N/A-' }}</p>
          <div class="plant-type bg-primary">
            <span>{{
              product.cannabis_attributes && product.cannabis_attributes.plant_type
            }}</span>
          </div>
        </div>

        <div class="plant-type-range content-margin-top">
          <div class="thc-wrapper color-primary">
            <span class="color-primary">THC</span>
            <span class="color-primary"> {{ product.thc_cbd_levels && product.thc_cbd_levels.thc_min }}
              -
              {{ product.thc_cbd_levels && product.thc_cbd_levels.thc_max }}
              {{
                product.thc_cbd_levels &&
                  product.thc_cbd_levels.concentration_unit
              }}</span>
          </div>
          <div class="cbd-wrapper color-primary">
            <span class="color-primary">CBD</span>
            <span  class="color-primary">{{ product.thc_cbd_levels && product.thc_cbd_levels.cbd_min }}
              -
              {{ product.thc_cbd_levels && product.thc_cbd_levels.cbd_max }}
              {{
                product.thc_cbd_levels &&
                  product.thc_cbd_levels.concentration_unit
              }}</span>
          </div>
        </div>
        <div class="qr-footer content-margin-top">
          <div class="scanner-wrapper">
            <p class="color-primary">more info</p>
            <div class="qr-scanner">
                <qrcode-vue :value="qrCodeValue" :size="304" />
                <!-- <img :src="logo" :height="vg_productSelectionType === 'image'? this.scale*20 : this.scale*20" width="vg_productSelectionType === 'image' ? this.scale*20: this.scale*20" class="qrcode-image" /> -->
            </div>
          </div>
          <div class="price-wrapper">
            <p class="color-primary">price</p>
            <div class="total-price-amount">
              <span class="color-primary">${{ (variant.sale_price && (variant.sale_price < variant.price)) ? variant.sale_price.toFixed(2) : variant.price >= 0 ? variant.price.toFixed(2) : 'N/A' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="corner-bottom-left"></div>
      <div class="corner-bottom-right"></div>
    </div>
</template>
  
<script>
  import { mapGetters } from 'vuex'
  import svgIcons from './icons'
  import QrcodeVue from 'qrcode.vue'
  
  const prod = {
    name: 'n/a',
    description: 'n/a',
    sku: 'n/a',
    image: 'n/a',
    product_type: 'n/a',
    product_family: 'n/a',
    weighing_unit: 'g',
    brand: {
      name: 'No Brand',
      logo: '',
      description: ''
    },
    category: {
      name: 'Pre-Roll',
      description: '',
      featured: false
    },
    aromas: [
      {
        name: 'Skunky',
        description: 'n/a',
        image: null
      }
    ],
    thc_cbd_levels: {
      thc_level: 'high',
      thc: 0,
      thc_min: 0,
      thc_max: 0,
      cbd_level: 'low',
      cbd: 0,
      cbd_min: 0,
      cbd_max: 0,
      concentration_unit: '%'
    },
    variants: []
  }
  
  export default {
    props: {
      pdftype: {
        type: String,
        default: null
      },
      customStyle: {
        type: String,
        default: null
      },
      product: {
        type: Object,
        default() {
          return prod
        }
      },
      variant: {
        type: Object,
        default() {
          return {
            price: null,
            size: null
          }
        }
      },
      isPdf: {
        type: Boolean,
        default() {
          return false
        }
      },
      qrCodeValue: {
        type: String,
        default() {
          return ''
        }
      },
      borders: {
        type: Boolean,
        default() {
          return true
        }
      }
    },
    components: {
      QrcodeVue
    },
    data() {
      return {
        logo: require('@/assets/images/Rectangle.jpg'),
        aromas: [
          { name: 'Cheesy' },
          { name: 'Citrusy' },
          { name: 'Earthy' },
          { name: 'Floral' },
          { name: 'Fruity' },
          { name: 'Herbal' },
          { name: 'Skunky' },
          { name: 'Spicy' },
          { name: 'Sweet' }
        ],
        svgIcons: svgIcons,
        loaded: true,
        price: null,
        sizes: [],
        weighing_unit: 'gms',
        scale: 2
      }
    },
    mounted() {
      this.computePriceAndSize(this.product)
      if (this.vg_productSelectionType === 'image') {
        this.scale = 3.5
      }
    },
    watch: {
      product(val) {
        this.computePriceAndSize(val)
      }
    },
    computed: {
      productCategory() {
        if (this.product.category && this.product.category.name) {
          return this.product.category.name
            .split(' ')
            .map(
              s =>
                `<span>${s.substring(0, 1)}</span>${s.substring(1)}`
            )
            .join(' ')
        }
        return `<span>F</span>eatured <span>P</span>roducts`
      },
      cssVars() {
        return {
          '--scale': `${this.scale}px`,
          '--product-brand-font': `${4.8 * this.scale}px`,
          '--product-card-width': `${258.819 * this.scale}px`, // 3.6512
          '--product-card-height': `${390 * this.scale}px`, // 3.6538
          '--product-card-h1-font-size': `${13 * this.scale}px`,
          '--product-card-h1-first-font-size': `${17 * this.scale}px`,
          '--product-card-h1-first-letter-font-size': `${17 * this.scale}px`,
          '--product-card-price-font': this.vg_productSelectionType === 'image' ? `120px` : `${28 * this.scale}px`, // `${28 * this.scale}px`,
          '--product-price-div-height': `${80 * this.scale}px`,
          '--thc-content-width': `${42 * this.scale}px`,
          '--thc-cbd-font-size': `${14.5 * this.scale}px`,
          '--thc-active-width': `${14.5 * this.scale}px`,
          '--thc-active-height': `${4.5 * this.scale}px`,
          '--thc-data-title-font': `${9 * this.scale}px`,
          '--product-category-height': `${17.5 * this.scale}px`,
          '--product-category-font': this.vg_productSelectionType === 'image' ? `48px` : `${11 * this.scale}px`,
          '--product-name-font': this.vg_productSelectionType === 'image' ? `76px` : `${19 * this.scale}px`,
          '--variant-weights-font': this.vg_productSelectionType === 'image' ? `42px` : `${10 * this.scale}px`,
          '--hr-margin': this.isPdf ? '0px 0px' : '12px 0px',
          '--price-width': this.vg_productSelectionType === 'image' ? '50%' : '67%',
          '--price-margin': this.vg_productSelectionType === 'image' ? `${10 * this.scale}px` : '0px',
          '--price-item-width': this.vg_productSelectionType === 'image' ? '90%' : 'fit-content'
        }
      },
      productAromas() {
        return this.product.aromas ? this.product.aromas.map(o => o.name) : []
      },
      background() {
        return this.vg_activeBusinessBrandingAndLogo.primary
      },
      ...mapGetters({
        vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo',
        productObj: 'locationproduct/productObj',
        getAromas: 'aroma/list',
        vg_productSelectionType: 'locationproduct/productSelectionType'
      })
    },
    methods: {
      computePriceAndSize(product) {
        let allPrices = []
        let allSizes = []
        if (Array.isArray(product.variants)) {
          this.product.variants.map(variant => {
            allPrices.push(variant.price)
            if (variant.size && variant.size !== '') {
              allSizes.push(variant.size)
            }
          })
        }
        this.price = Math.min(...allPrices)
        if (allPrices.length === 0) this.price = 'n/a'
        this.sizes = [...new Set(allSizes)]
      },
      downloadPDF() {
        this.loaded = false
        this.$refs.html2Pdf.generatePdf()
      }
    }
  }
  </script>
  
  <style>
     @import url('https://fonts.googleapis.com/css2?family=Alegreya+SC:wght@500;700;800&display=swap');
      .qr-wrapper {
        background: #fff;
        width: 900px;
        height: 1425px;
        margin: 0 auto;
        border: 1px solid #c4c4c4;
        position: relative;
      }
      .hero-qr {
        height: 138px;
        padding: 24px 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--v-primary-base);
      }
      .color-primary{
        color: var(--v-primary-base) !important;
      }
      .bg-primary{
        background: var(--v-primary-base) !important;
      }
      .hero-qr h1 {
        text-transform: uppercase;
        text-align: center;
        font-weight: 500;
        font-size: 60px;
        line-height: 72px;
        color: #fff;
        font-family: 'AlegreyaSC-Medium'; 
        font-weight: 500;
      }
      .hero-qr h1  span{
        font-size: 74px;
      }
      .qr-items-content {
        padding: 0px 54px;
      }
      .qr-items-content h3 {
        height: 38px;
        font-size: 32px;
        line-height: 38.4px;
        letter-spacing: 2px;
        color: #000;
        margin-top: 108px;
        text-transform: uppercase;
        overflow: hidden;
        font-family: 'AlegreyaSC-Light';
      }
      .qr-items-content h3 span{
        font-size: 40px;
      }
      .qr-items-content h2 {
        font-weight: 400;
        height: 228px;
        font-size: 76px;
        letter-spacing: 1.25px;
        line-height: 76px;
        color: #000;
        margin-top: 108px;
        overflow: hidden;
      }
      .qr-items {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 40px;
        padding-bottom: 40px;
      }
      .plant-type-wrapper p {
        text-transform: uppercase;
        font-weight: 900;
        font-size: 38px;
        height: 48px;
        line-height: 47.5px;
        letter-spacing: 0.5px;
        color: #5f6738;
        margin-bottom: 0px;
        font-family: 'AlegreyaSC-Black';
      }
      .plant-type-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* padding-bottom: 70px; */
        height: 76px;
        margin-top: 108px;
      }
      .plant-type {
        width: 231px;
        height: 76px;
        border-radius: 6px;
        background: #5f6738;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .plant-type span {
        text-transform: uppercase;
        font-weight: 900;
        font-size: 48px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        letter-spacing: 0.5px;
        color: #fff;
        font-family: 'AlegreyaSC-Black';
      }
      .plant-type-range {
        display: flex;
        justify-content: space-between;
        height: 106px;
        position: relative;
        overflow: hidden;
        margin-top: 108px;
      }
      .thc-wrapper,
      .cbd-wrapper {
        display: flex;
        flex-direction: column;
      }
      .thc-wrapper{
        width: 304px;
      }
      .cbd-wrapper{
        width: 384px;
      }
      .thc-wrapper span:first-child,
      .cbd-wrapper span:first-child {
        height: 34px;
        margin-bottom: 16px;
        color: #404828;
        font-weight: 500;
        font-size: 34px;
        line-height: 34px;
        letter-spacing: 0.1px;
      }
      .thc-wrapper span:last-child,
      .cbd-wrapper span:last-child {
        height: 56px;
        font-weight: 400;
        font-size: 56px;
        color: #404828;
        line-height: 56px;
        letter-spacing: 0.5px;
      }
      .price-wrapper p,
      .scanner-wrapper p {
        text-transform: uppercase;
        color: #404828;
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;
        letter-spacing: 0.1px;
        margin-bottom: 16px;
      }
      .total-price-amount {
        width: 384px;
        height: 304px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #eff0eb;
      }
      .total-price-amount span {
        font-weight: 500;
        font-size: 120px;
        padding-left: 32px;
        padding-right: 32px;
        line-height: 100px;
        color: #404828;
      }
      .qr-scanner {
        width: 310px;
        height: 304px;
        position: relative;
      }
      .qr-scanner img{

      }
      .qr-scanner p {
        text-transform: uppercase;
        color: #404828;
        padding-bottom: 18px;
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;
        letter-spacing: 0.1px;
      }
      .qr-footer {
        display: flex;
        justify-content: space-between;
        height: 352px;
        position: relative;
        overflow: hidden;
        margin-top: 108px;
      }
      .plant-type-wrapper,
      .thc-wrapper span:first-child,
      .cbd-wrapper span:first-child,
      .scanner-wrapper p,
      .price-wrapper p {
        font-family: 'AlegreyaSC-Medium';
      }
      .qr-items-content h3 {
        font-family: 'AlegreyaSC-Medium';
      }
      .qr-items-content h2,
      .thc-wrapper span:last-child,
      .cbd-wrapper span:last-child,
      .total-price-amount span {
        font-family: 'BebasNeue-Bold';
      }
      .content-margin-top {
        margin-top: 70px !important;
      }
      .corner-bottom-left {
        position: absolute;
        border-top: 1px solid #c4c4c4;
        border-right: 1px solid #c4c4c4;
        width: 16px;
        height: 16px;
        bottom: 0;
      }
      .corner-bottom-right {
        position: absolute;
        border-top: 1px solid #c4c4c4;
        border-left: 1px solid #c4c4c4;
        width: 16px;
        height: 16px;
        bottom: 0;
        right: 0;
      }
      .corner-top-left {
        position: absolute;
        border-bottom: 1px solid #c4c4c4;
        border-right: 1px solid #c4c4c4;
        width: 16px;
        height: 16px;
        top: 0;
      }
      .corner-top-right {
        position: absolute;
        border-bottom: 1px solid #c4c4c4;
        border-left: 1px solid #c4c4c4;
        width: 16px;
        height: 16px;
        top: 0;
        right: 0;
      }
      .qrcode-image {
        position: absolute;
        top: 112px;
        left: 124px;
    }
    </style>
